import { connect } from "react-redux";
import AnalyticsProfileComponent from "../../Components/Dashboard/Analytics/AnalyticsProfileComponent";
import { setAnalyticsProfiles } from "../../Redux/Actions/AnalyticsActions";

const mapStateToProps = (state) => ({
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  ANALYTICS_PROFILES: state.reducer.ANALYTICS_PROFILES,
  SCOPES_NAMES: state.reducer.SCOPES_NAMES,
});

const mapDispatchToProps = {
  setAnalyticsProfiles,
};

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsProfileComponent);
